import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/components/LegalPage";
import { LegacyPolicyBody } from "@/components/LegacyPolicyBody";
import { legacyPolicies } from "@/data/legacy-policies";

export const Route = createFileRoute("/sustainability-policy")({
  head: () => {
    const head = legalHead({
      title: "Sustainability Policy | Preserve Earth",
      description:
        "Preserve Earth's sustainability policy on environmental impact, fair treatment of employees and suppliers, responsible operations and continuous improvement.",
      path: "/sustainability-policy",
      crumbName: "Sustainability Policy",
    });
    return { ...head, meta: [...head.meta, { name: "robots", content: "index, follow" }] };
  },
  component: SustainabilityPage,
});

function SustainabilityPage() {
  return (
    <LegalPage
      crumb={{ name: "Sustainability Policy", path: "/sustainability-policy" }}
      showPolicyContact={false}
      intro={<LegacyPolicyBody blocks={legacyPolicies.sustainability} />}
    />
  );
}
